import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { FormGroup, UntypedFormGroup } from '@angular/forms';

/**
 * Vendored from @ismaestro/ngx-scroll-to-first-invalid@18.0.0 (MIT).
 * The package is abandoned and caps its Angular peer range at 18.x,
 * blocking clean npm installs on Angular 19+. Same selector and behavior,
 * minus the Ionic branch we never used.
 */
@Directive({
  selector: '[ngxScrollToFirstInvalid]',
  standalone: true,
})
export class NgxScrollToFirstInvalidDirective {

  @Input() formGroup: FormGroup | UntypedFormGroup | null = null;

  constructor(private el: ElementRef) {}

  private static scrollToElement(element: HTMLElement): void {
    if (element) {
      const offset = element.getBoundingClientRect().top + window.scrollY - 150;
      window.scroll({
        behavior: 'smooth',
        left: 0,
        top: offset,
      });
      setTimeout(() => {
        element.focus();
        element.blur(); // Trigger error messages
        element.focus();
      }, 500);
    }
  }

  private static markFormGroupTouched(formGroup: FormGroup | UntypedFormGroup | null): void {
    if (formGroup) {
      Object.values(formGroup.controls).forEach((control) => {
        control.markAsTouched();
        if (control instanceof FormGroup) {
          NgxScrollToFirstInvalidDirective.markFormGroupTouched(control);
        }
      });
    }
  }

  @HostListener('submit', ['$event'])
  onSubmit(event: Event): void {
    event.preventDefault();
    if (this.formGroup && !this.formGroup.valid) {
      NgxScrollToFirstInvalidDirective.markFormGroupTouched(this.formGroup);
      const formControlInvalid = this.el.nativeElement.querySelector('.ng-invalid');
      if (formControlInvalid) {
        return NgxScrollToFirstInvalidDirective.scrollToElement(formControlInvalid);
      }
      const formGroupInvalid = this.el.nativeElement.querySelectorAll('form .ng-invalid');
      if (formGroupInvalid && formGroupInvalid.length) {
        return NgxScrollToFirstInvalidDirective.scrollToElement(formGroupInvalid[0]);
      }
      return NgxScrollToFirstInvalidDirective.scrollToElement(this.el.nativeElement);
    }
  }
}
